<template>
    <div>
        <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" >
				<el-form-item>
					<el-input  placeholder=""></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getUsers">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="add()">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
        
        <el-table :data="tableData" height="500" style="width: 100%">
            <el-table-column prop="visitor" label="姓名" width="100"></el-table-column>
            <el-table-column prop="visitorIdcard" label="身份证" width="160"></el-table-column>
            <el-table-column prop="visitorDep" label="来访单位"  width="200"></el-table-column>
             <!-- <el-table-column prop="visitorPhone" label="手机号码"  width="200"></el-table-column> -->
            <el-table-column label="预约到达日期" width="180">
			<template slot-scope="scope">{{ scope.row.visitTime | moment('YYYY-MM-DD HH:mm:ss') }}</template>
            </el-table-column>
            <el-table-column  prop="visitContent" label="来访原因"  width="220"> </el-table-column>
            <el-table-column label="预约信息状态"  width="130">
              <template slot-scope="scope">{{appoint(scope.row.state)}}</template>
            </el-table-column>
            <!-- <el-table-column label="操作" min-width="150">
                <template slot-scope="scope">
                    <el-button size="small" @click="edit(scope.$index,scope.row)">编辑</el-button>
                    <el-button size="small" type="danger" @click="deleteRow(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <el-pagination
		 	class="pull-right clearfix"
			@current-change="handleCurrentChange"
			:current-page="currentPage"
			:page-size="totalsize" 
			layout="total, prev, pager, next, jumper"
			:total="total" >
		</el-pagination>
     </div>    
</template>
<script>
    import { url, RequestGet } from '../../api/api';
    import { PageSize } from '../../api/api';
    import {appoint} from '../../api/format';
    export default {
         data() {
      return {
        total:0,     //数据的总数量
		totalsize:0,  //总的页数 = 总数量/每页显示的条数
		currentPage:1,
		page:{
			pageSize:PageSize,   //一页显示的条数
            criteria:'',
            loginId:sessionStorage.getItem("userId")
		},
        tableData: [],
        formcolWidth:'120px',
        dialogFormVisible: false
      }
    },
    methods: {
        appoint,
         handleSizeChange(val) {
		console.log(`每页 ${val} 条`);
            },
      handleCurrentChange(val) {
		console.log(`当前页: ${val}`);
		this.pageNumber = val;
        this.page.pageNumber = val;
        this.loadData();
      },
      loadData(){
           RequestGet('/visit/findById',this.page).then(response => {
                 console.log(response);
                 this.tableData = response.data;
                 this.total = response.page.totalCount; 
				 this.totalsize  = response.page.pageSize;
                }).catch(error => {           
          })
      },
      deleteRow(index, rows) {
       this.$confirm('是否确认删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
            this.$message({
                type: 'success',
                message: '删除成功!'
            });
            this.dialogFormVisible = false;
            
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });          
            });
      },
      edit(index,rows){
        this.dialogFormVisible = true;   
        this.form = rows;
      },
      add(){
           this.$router.push({ path: '/appointment' });
      },
      getUsers(){

      },
       open2() {
            this.$confirm('是否修改该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
            this.$message({
                type: 'success',
                message: '修改成功!'
            });
            this.dialogFormVisible = false;
            
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消修改'
            });          
            });
      },
      formatterColumn(row, column) {
            switch(row.state){
                
                case "10":
                return '审核通过';
                break;

                case "20":
                return '待审核';
                break;

                default:
                return '未知';
            }
        },

    },
    created:function(){
           this.loadData();
    },
   
  }
</script>


// WEBPACK FOOTER //
// record.vue?1e317a9e